import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/moment";

import { FormDateTimePickerProps } from "../../interface/formik/FormDateTimePickerProps";

const FormDateTimePicker = ({
  value,
  label,
  onChange,
  clearable,
  minDate,
  readOnly,
}: FormDateTimePickerProps) => {
  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimePicker
          inputVariant="outlined"
          value={value}
          onChange={onChange}
          label={label}
          clearable={clearable}
          minDate={minDate}
          readOnly={readOnly}
          fullWidth
        />
      </MuiPickersUtilsProvider>
    </>
  );
};

export default FormDateTimePicker;
